import { CtaCardFragmentFragment } from '../../__generated__/graphql';
import ButtonLink from '../../components/Button/ButtonLink';
import GradientBorderCard from '../../components/GradientBorderCard';
import { Heading2, Paragraph } from '../../components/Text';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

import style from './cta-card.module.css';

const CtaCard: ContentBlock<CtaCardFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.ctaCard;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
    >
      <GradientBorderCard backgroundColor="black">
        <Heading2
          fontSizeOverride={38}
          fontWeight={300}
        >
          {contentBlockProps.heading}
        </Heading2>

        <Paragraph className={style.ctaCardText}>
          {contentBlockProps.text}
        </Paragraph>

        <div
          className={style.ctaCardButtons}
        >
          <ButtonLink
            buttonColor="white"
            id={contentBlockProps.buttonId ?? undefined}
            linkFragment={contentBlockProps.secondaryButton}
          />

          <ButtonLink
            buttonColor="orange"
            id={contentBlockProps.buttonId ?? undefined}
            linkFragment={contentBlockProps.button}
          />
        </div>
      </GradientBorderCard>
    </Section>
  );
};

export default CtaCard;
